import { Component, OnInit, Input, Inject, EventEmitter, Output } from '@angular/core';
import { Location, CurrencyPipe } from '@angular/common';
import { UntypedFormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService, ConstantService } from '@app/_services';
import { ApiResponse } from '@app/_models';
import { Feature } from '@app/_components/property/feature';
import { FeatureService } from '@app/_components/property/feature';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { RateBucketDetail, RateBucketDetailService } from '../rate-bucket-detail';
import { PercentageValuesPositive, PercentageValuesNegative, PercentageValuesPositiveAndNegative } from '../../../_helpers/constants';
import { RateManagerService } from '../rate-manager/rate-manager.service';
import { RateBucketService } from '../rate-bucket/rate-bucket.service';
import { RateBucket } from '../rate-bucket/rate-bucket';
import { RateOverrideService } from './rate-override.service';


@Component({
    selector: 'app-rate-override',
    templateUrl: './rate-override.component.html',
    styleUrls: ['./rate-override.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class RateOverrideComponent implements OnInit {
	locationIds: any[];

	constructor(
		private currencyPipe: CurrencyPipe,
		private rateOverrideService: RateOverrideService,
		private rateManagerService: RateManagerService,
		private rateBucketService: RateBucketService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		private constantService: ConstantService,
		private dialog: MatDialog,
	) {

		this.locationIds = this.constantService.locations;
	}

	ngOnInit(): void {
	}


	@Input() shortTermRentalId: number;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();


	// data
	apiResponse: ApiResponse;

	//
	autoTicks = false;
	disabled = false;
	invert = false;
	max = 1;
	min = -1;
	step = .01;
	tickInterval = .01;
	showTicks = true;
	thumbLabel = false;
	value = 0;
	vertical = false;



	rateBucketTypes = [
		{ value: 'RC', name: 'Auto' },
		{ value: 'SP', name: 'Manual' }
	];


	seasonCategories = [
		{ value: 1, name: 'Low' },
		{ value: 2, name: 'Low-Medium' },
		{ value: 3, name: 'Medium' },
		{ value: 4, name: 'Medium-High' },
		{ value: 5, name: 'High' },
	];


	discountAlorithms = [
		{ value: '1', name: 'Straight Line' },
	];

}
